import React, { useState, useEffect } from "react";
import { Col, InputGroup, Row, Form, Button } from "react-bootstrap";
import { GenerateLinkRequest, Link } from "src/types/link";
import CopyLink from "../copyLink";
import Collapse from "../../../animation/collapse";
import CustomButton from "src/components/button";

import styles from "./linkcontainer.module.scss";
import _ from "lodash";
import cx from "classnames";
import EmailAutoCompleteView from "src/legacy/components/EmailAutoComplete/EmailAutoCompleteView";
import { useSelector } from "react-redux";
import { useAssetAdoption } from "src/redux/actions/adoption/asset";
import { Asset } from "src/types/assets";
import { Collection } from "src/types/collections";
import { ASSET_DETAIL, COLLECTION_DETAIL } from "src/constants/adoption/sourceTypes";
import Text from "src/components/text";

interface LinkContainerProps {
  linkType: string;
  value?: string;
  entity: Asset | Collection;
  setValue?: (value: string) => void;
  link: Link;
  setCurrentTab: (tab: string) => void;
  className?: string

  linkMetaData: {
    title: string;
    sub_text: string;
    placeholder?: string;
  };

  handleShowSettings: (value: boolean) => void;
  handleGenerateLink: (request: GenerateLinkRequest) => void;
}

const LinkContainer: React.FC<LinkContainerProps> = ({
  linkType,
  linkMetaData,
  entity,
  value,
  setValue,
  handleShowSettings,
  link,
  handleGenerateLink,
  setCurrentTab,
  className
}) => {
  const [isInputValid, setIsInputValid] = useState<boolean | null>(null);
  const [revealLink, setRevealLink] = useState<boolean>(false);

  const { trackGenerateLink } = useAssetAdoption();

  useEffect(() => {
    if (linkType === _.get(link, "type")) {
      setRevealLink(true);
    } else {
      setRevealLink(false);
      if (setValue) {
        setValue("");
      }
    }
  }, [link]);

  const handleToggleLinkSettings = (flag: boolean) => {
    handleShowSettings(flag);
    setCurrentTab("generate_link");
  };
  const handleChange = (inputValue: string) => {
    if (setValue) {
      setValue(inputValue);
    }
    if (inputValue.length > 1) {
      setIsInputValid(true);
    } else {
      setIsInputValid(false);
      if (revealLink) {
        setRevealLink(false);
      }
    }
  };
  const handleClick = () => {
    let linkRequest: GenerateLinkRequest = {
      type: linkType,
    };
    if (linkType === "personalised") {
      if (value) {
        linkRequest = {
          ...linkRequest,
          email: value,
        };
      }
    } else if (linkType === "campaign") {
      if (value) {
        linkRequest = {
          ...linkRequest,
          utmCampaign: {
            name: value,
          },
        };
      }
    }


    if (entity.entityType === "asset") {
      trackGenerateLink({
        sourceCta: ASSET_DETAIL,
        linkType: _.capitalize(linkType),
      });
    } else {
      trackGenerateLink({
        sourceCta: COLLECTION_DETAIL,
        linkType: _.capitalize(linkType),
        collectionName: _.get(entity, "name", ""),
      });
    }

    handleGenerateLink(linkRequest);
  };

  const handleEmailSelect = (email: any) => {
    const contact = _.get(email, "0");
    const isExistingContact = _.get(contact, "type") === "contact";
    let mail = "";

    if (isExistingContact && setValue) {
      mail = _.get(contact, "value.email");
    } else {
      mail = _.get(contact, "value");
    }
    if (mail) {
      if (setValue) {
        setValue(mail);
      }
    }
    const regex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (regex.test(mail)) {
      setIsInputValid(true);
    } else {
      setIsInputValid(false);
      if (revealLink) {
        setRevealLink(false);
      }
    }
  };
  return (
    <div className={cx(styles.container, className)}>
      <Row className={styles.linkSection}>
        <Col xl={12}>
          <div className={cx(styles.linkTypeTitle)}>{linkMetaData.title}</div>
          {linkType === "anonymous" &&
            <CustomButton variant="tertiary">
              <i className={"paperflite-arrow-up"}></i>
              Get Link
            </CustomButton>
          }
        </Col>
        <Col xl={12}>
          <div
            className={cx(styles.linkTypeSubTitle, {
              [styles.linkTypeSubTitleAnonymous]: linkType === "anonymous",
            })}
          >
            {linkMetaData.sub_text}
          </div>
        </Col>
        <Col xl={12}>
          {(linkType === "campaign" || linkType === "personalised") && (
            <Form onSubmit={(e) => e.preventDefault()}>
              <InputGroup className={styles.inputGroup}>
                {linkType === "campaign" && <Form.Control
                  placeholder={linkMetaData.placeholder}
                  aria-label={linkMetaData.placeholder}
                  aria-describedby="basic-addon2"
                  className={styles.linkInput}
                  value={value}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    handleChange(event.target.value);
                    if (!event.target.value.trim()) {
                      setIsInputValid(false);
                      if (revealLink) {
                      setRevealLink(false);
                      }
                    }
                  }}
                />
                }
                {
                  linkType === "personalised" &&
                  <div className={styles.emailAutoComplete}>
                    <EmailAutoCompleteView
                      className={styles.linkInput}
                      onChange={handleEmailSelect}
                      entityType="contact"
                      placeholder="Enter email here"
                      contactSource="generate_link"
                      hideRemoveIcon={revealLink}
                      clearValue={value === ""}
                      isInputValid={isInputValid}
                    />
                  </div>
                }
                <Button className={styles.inputAddon}>
                  {!revealLink && value && (
                    <i
                      onClick={handleClick}
                      className={cx(
                        cx("fa-solid fa-arrow-right-long", {
                          [styles.showIcon]: isInputValid,
                        }),
                      )}
                    ></i>
                  )}

                  {revealLink && (
                    <i
                      className={cx(
                        cx("paperflite-close", styles.closeIcon, {
                          [styles.showIcon]: isInputValid,
                        }),
                      )}
                      onClick={() => {
                        if (setValue) {
                          setValue("");
                        }
                        setRevealLink(false);
                      }}
                    ></i>
                  )}
                </Button>
              </InputGroup>
            </Form>
          )}
        </Col>
        <Collapse isOpen={revealLink}>
          <Row className={cx(styles.linkContainer)}>
            <Col xl={9} xs={9} sm={9} className={styles.linkUrl}>
              <span className={styles.generatedLink}>
                <Text className={styles.truncate} text={_.get(link, "url") || ""} lines={1} />
              </span>
            </Col>
            <Col xl={3} sm={3} xs={3} className={styles.linkActions}>
              <CopyLink link={link} />
              <div className={styles.verticalBorder}></div>
              <i
                className={cx("paperflite-settings-wheel")}
                onClick={() => handleToggleLinkSettings(true)}
              ></i>
            </Col>
          </Row>
        </Collapse>
      </Row>
    </div>
  );
};

const AnonymousLinkContainer: React.FC<LinkContainerProps> = ({
  linkType,
  linkMetaData,
  value,
  entity,
  setValue,
  handleShowSettings,
  link,
  handleGenerateLink,
  setCurrentTab,
  className
}) => {

  const { trackGenerateLink } = useAssetAdoption();

  const [revealLink, setRevealLink] = useState<boolean>(false);

  const generating = useSelector(state => {
    const type = _.get(state, 'link.generateLink.type');
    if(type === 'anonymous'){
      return _.get(state, 'link.generateLink.creating');
    }

    return false;
  });

  const generated = useSelector(state => {
    const type = _.get(state, 'link.generateLink.type');
    if(type === 'anonymous'){
      return _.get(state, 'link.generateLink.created');
    }

    return false;
  });

  useEffect(() => {
    if (linkType === _.get(link, "type")) {
      setRevealLink(true);
    } else {
      setRevealLink(false);
      if (setValue) {
        setValue("");
      }
    }
  }, [link]);

  const handleToggleLinkSettings = (flag: boolean) => {
    handleShowSettings(flag);
    setCurrentTab("generate_link");
  };


  const handleClick = () => {
    const linkRequest: GenerateLinkRequest = {
      type: linkType,
    };

    if (entity.entityType === "asset") {
      trackGenerateLink({
        sourceCta: ASSET_DETAIL,
        linkType: _.capitalize(linkType),
      });
    } else {
      trackGenerateLink({
        sourceCta: COLLECTION_DETAIL,
        linkType: _.capitalize(linkType),
        collectionName: _.get(entity, "name", ""),
      });
    }

    handleGenerateLink(linkRequest);
  };
  
  return (
    <div className={cx(styles.container, className)}>
      <Row className={styles.linkSection}>
        <Col xl={12} className={styles.anonymousHeader}>
          <div className={cx(styles.linkTypeTitle)}>{linkMetaData.title}</div>
          <CustomButton variant="tertiary" className={styles.linkButton} disabled={generating || generated} onClick={handleClick}>
            {!generating && <i className={"paperflite-arrow-up"}></i>}
            {generating ? 'Generating...' : 'Get Link'}
          </CustomButton>
        </Col>
        <Col xl={12}>
          <div className={cx(styles.linkTypeSubTitle, styles.linkTypeSubTitleAnonymous)}>
            {linkMetaData.sub_text}
          </div>
        </Col>
        <Collapse isOpen={revealLink}>
          <Row className={cx(styles.linkContainer)}>
            <Col xl={9} xs={9} sm={9} className={styles.linkUrl}>
              <span className={styles.generatedLink}>
                <Text className={styles.truncate} text={_.get(link, "url") || ""} lines={1} />
              </span>
            </Col>
            <Col xl={3} sm={3} xs={3} className={styles.linkActions}>
              <CopyLink link={link} />
              <div className={styles.verticalBorder}></div>
              <i
                className={cx("paperflite-settings-wheel")}
                onClick={() => handleToggleLinkSettings(true)}
              ></i>
            </Col>
          </Row>
        </Collapse>
      </Row>
    </div>
  );
};

export { LinkContainer, AnonymousLinkContainer };
